import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { cellsToJson } from '../../common/graph-utils';
import { LOCAL_STORAGE_KEY } from '../../constants';
export var NsGraphCopySelection;
(function (NsGraphCopySelection) {
    /** Command: 用于注册named factory */
    NsGraphCopySelection.command = XFlowGraphCommands.GRAPH_COPY;
    /** hookName */
    NsGraphCopySelection.hookKey = 'graphCopySelection';
})(NsGraphCopySelection || (NsGraphCopySelection = {}));
let GraphCopySelectionCommand = class GraphCopySelectionCommand {
    constructor() {
        this.parseCells = (cells) => {
            // if groupNode add its group children
            cells.forEach(cell => {
                const data = cell.getData();
                if (cell.isNode() && data.isGroup) {
                    const children = cell.getChildren();
                    children.forEach(child => {
                        cells.push(child);
                    });
                }
            });
            // filter edges target not in selections
            const nodeIds = cells.filter(cell => cell.isNode()).map(cell => cell.id);
            const map = cells.reduce((acc, cell) => {
                if (cell.isEdge()) {
                    const source = cell.getSourceCellId();
                    const target = cell.getTargetCellId();
                    if (source && target) {
                        if (nodeIds.includes(source) && nodeIds.includes(target)) {
                            acc.set(cell.id, cell);
                        }
                    }
                }
                else {
                    acc.set(cell.id, cell);
                }
                return acc;
            }, new Map());
            const uniqeList = Array.from(map.values());
            return cellsToJson(uniqeList);
        };
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.graphCopySelection.call(args, () => __awaiter(this, void 0, void 0, function* () {
                const graph = yield ctx.getX6Graph();
                const cells = graph.getSelectedCells();
                const edges = graph.getEdges();
                // 处理 Group cells/过滤无效的edges
                const jsonObject = this.parseCells([...cells, ...edges]);
                const oldJsonString = window.localStorage.getItem(LOCAL_STORAGE_KEY);
                // 写cache
                window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(jsonObject));
                // undo 写cache
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    window.localStorage.setItem(LOCAL_STORAGE_KEY, oldJsonString);
                })));
                return { err: null };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphCopySelectionCommand.prototype, "contextProvider", void 0);
GraphCopySelectionCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphCopySelection.command.id },
    })
    /** 创建节点命令 */
], GraphCopySelectionCommand);
export { GraphCopySelectionCommand };
//# sourceMappingURL=graph-copy.js.map